import { OCT_STATES } from '@campaign-management/app/constants/campaign-management-states.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const CAMPAIGN_MANAGEMENT_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${OCT_STATES.PROJECT}.**`,
  url: '/oct',
  loadChildren: () =>
    import('@campaign-management/app/campaign-management.module').then((m) => m.CampaignManagementModule),
};

export const APP_STATES = [CAMPAIGN_MANAGEMENT_MODULE_STATE];
